export default async function(to, from, next) {
	const user = this.state.currentUser;

	if (user.school?.id === 134) {
		return next("/student/review-center");
	} else {
		return next();
	}
}
